module.exports = __webpack_public_path__ + "img/fordy.04e5d5f7.jpg";